import { render, staticRenderFns } from "./XiaomiSettings.vue?vue&type=template&id=52a8b194&"
import script from "./XiaomiSettings.vue?vue&type=script&lang=ts&"
export * from "./XiaomiSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports